import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CenteredContainer, Stack, Box } from '@nerdwallet/currency';

import CompanyPeopleTile from './company-people-tile';
import CompanyPeopleTileWide from './company-people-tile-wide';

import styles from './people.module.less';

const CompanyPeople = ({ isSpecialist, people }) => {
  const renderedPeople = _.map(people, (person, name) => (
    <CompanyPeopleTile
      isSpecialist={isSpecialist}
      key={`item-${name}`}
      {...person}
    />
  ));

  const renderedPeopleWide = _.map(people, (person, name) => (
    <CompanyPeopleTileWide
      isSpecialist={isSpecialist}
      key={`item-${name}`}
      {...person}
    />
  ));

  return (
    <CenteredContainer>
      <Stack className={styles.mobileLayout}>{renderedPeople}</Stack>
      <Box
        className={styles.wideLayout}
        display="flex"
        flexWrap="wrap"
        justifyContent="space-between"
      >
        {renderedPeopleWide}
      </Box>
    </CenteredContainer>
  );
};

CompanyPeople.displayName = 'CompanyPeople';

CompanyPeople.propTypes = {
  isSpecialist: PropTypes.bool,
  name: PropTypes.string,
  people: PropTypes.arrayOf(PropTypes.shape(CompanyPeople.propTypes)),
};

export default CompanyPeople;
